import React, { useReducer, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../Privacy.css";
import _ from "lodash";
import ViewUploadedPdf from "../PrivacyModal/ViewUploadedPdf";
import ViewPolicyHistoryModal from "../PrivacyModal/ViewPolicyHistoryModal";
import { isAdmin, reducer, type } from "../../helper/Constant";
import DOMPurify from 'dompurify';

import "./PolicyCard.css";
import DeletePolicyModal from "../PrivacyModal/DeletePolicyModal";
import { Dropdown } from "react-bootstrap";
import SignPolicyModal from "../PrivacyModal/SignPolicyModal";
import { signPolicy, bulkSignPolicy } from "../../../config/services/employeeServices";
import { setResponseAction } from "../../helper/Constant";

const initialState = {
    doc: "",
    openDropDown: false,
    openEditModal: false,
    privacyId: "",
    openDeleteModal: false,
    editTitle: "",
    docLink: "",
    openHistoryModal: false,
};

const PolicyCard = (props) => {
    const {
        getPolicyList,
        titleErrorMsg,
        uploadFile,
        uploadFileErrorMsg,
        title,
        handleChange,
        dispatchProps,
        policyList,
        department,
        departmentErrorMsg,
        statusErrorMsg,
        descriptionErrorMsg,
        handleDepartmentChange,
    } = props;
    const [state, dispatch] = useReducer(reducer, initialState);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const {
        openViewDoc,
        doc,
        openEditModal,
        privacyId,
        openDeleteModal,
        editTitle,
        docLink,
        openHistoryModal,
    } = state;

    const [openSignModal, setOpenSignModal] = useState(false);
    const [selectedPolicyIds, setSelectedPolicyIds] = useState([]);
    const [isBulkSigning, setIsBulkSigning] = useState(false);

    // Filter policies that are active and NOT signed by the user
    // Only for non-admin users
    const getPendingPolicies = () => {
        if (isAdmin === "1" || isAdmin === "4") return [];
        return policyList.filter(p =>
            (p.status === 1 || p.status === "1") &&
            (!props.signedPolicies || !props.signedPolicies.includes(p._id))
        );
    };

    const pendingPolicies = getPendingPolicies();

    const handleSignClick = (id) => {
        setSelectedPolicyIds([id]);
        setIsBulkSigning(false);
        setOpenSignModal(true);
    };

    const handleBulkSignClick = () => {
        // Select all pending policies
        const pendingIds = pendingPolicies.map(p => p._id);
        setSelectedPolicyIds(pendingIds);
        setIsBulkSigning(true);
        setOpenSignModal(true);
    };

    const handleSignSuccess = (message) => {
        dispatchProps({
            type: type,
            payload: {
                resMsg: true,
                successMessage: message || "Policy Signed",
            },
        });
        setResponseAction({ dispatch: dispatchProps });
        if (props.onPolicySigned) {
            props.onPolicySigned();
        }
        setSelectedPolicyIds([]);
    };

    const handleViewHistory = (id) => {
        dispatch({
            type: type,
            payload: {
                privacyId: id,
                openHistoryModal: true,
            },
        });
    };

    const closeModal = () => {
        dispatch({
            type: type,
            payload: {
                doc: "",
                openViewDoc: false,
                openEditModal: false,
                privacyId: "",
                openDeleteModal: false,
                editTitle: "",
                editTitle: "",
                docLink: "",
                openHistoryModal: false,
            },
        });
        dispatchProps({
            type: type,
            payload: {
                uploadFile: "",
                uploadFileErrorMsg: "",
                title: "",
                titleErrorMsg: "",
                toAddOrEdit: "",
            },
        });
        setOpenSignModal(false);
    };

    const handleOpenModal = (props) => {
        const { openModal, id, editTitle, department, version, icon, description, status } = props;
        if (editTitle) {
            dispatchProps({
                type: type,
                payload: {
                    title: editTitle,
                    department,
                    icon,
                    description,
                    status,
                },
            });
        }
        dispatch({
            type: type,
            payload: {
                [openModal]: true,
                privacyId: id,
                editTitle: editTitle,
            },
        });
    };

    const handleDownload = (link) => {
        window.open(link);
    };

    // Sort policyList by title in ascending order
    const sortedPolicyList = policyList.sort((a, b) => {
        const titleA = a.title ? a.title.charAt(0).toUpperCase() : '';
        const titleB = b.title ? b.title.charAt(0).toUpperCase() : '';
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
    });

    return (
        <>
            <div className={`policy-container ${props.viewMode === 'list' ? 'list-view' : 'grid-view'}`}>

                {/* Sign All Pending Button - Only for Non-Admins with pending policies */}
                {(isAdmin !== "1" && isAdmin !== "4" && pendingPolicies.length > 0) && (
                    <div className="w-100 mb-3 d-flex justify-content-end">
                        <button
                            className="btn btn-primary font-weight-bold shadow-sm"
                            onClick={handleBulkSignClick}
                        >
                            <i className="fa fa-pencil-square-o mr-2"></i>
                            Sign All Pending ({pendingPolicies.length})
                        </button>
                    </div>
                )}

                {!_.isEmpty(sortedPolicyList) &&
                    sortedPolicyList.map((data, i) => {
                        return (
                            <div className="policy-new-card" key={i} onClick={() => handleViewHistory(data._id)} style={{ cursor: 'pointer' }}>
                                <div className="policy-card-header">
                                    <div className="policy-icon" style={{ backgroundColor: "#e3f2fd" }}>
                                        <i className={`fa ${data.icon || 'fa-file-text'}`} style={{ color: "#1976d2" }}></i>
                                    </div>
                                    <div className="policy-version badge badge-light">{`v${data.version}`}</div>
                                    {(isAdmin === "4" || isAdmin === "1") && (
                                        <Dropdown className="policy-card-dropdown" onClick={(e) => e.stopPropagation()}>
                                            <Dropdown.Toggle as="div" className="no-caret cursor-pointer">
                                                <i className="fa fa-ellipsis-v text-muted" aria-hidden="true"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="policy-menu">
                                                <>
                                                    <Dropdown.Item onClick={() => history.push(`/policies/edit/${data._id}`)}>
                                                        Update Policy
                                                    </Dropdown.Item>
                                                    {(data.status !== 3 && data.status !== "3") && (
                                                        <Dropdown.Item onClick={() => handleOpenModal({ openModal: "openDeleteModal", id: data._id })}>
                                                            Move to Archive
                                                        </Dropdown.Item>
                                                    )}
                                                </>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                                </div>

                                <h5 className="policy-title">
                                    {data.title}
                                </h5>
                                <div className="policy-description text-muted"
                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.description || "No description provided.") }}
                                />

                                <div className="policy-meta mt-auto">
                                    <div className="meta-item">
                                        <span className="meta-label">DEPARTMENT</span>
                                        <span className="meta-value">{data.department || "General"}</span>
                                    </div>
                                    {data.updated && (
                                        <div className="meta-item">
                                            <span className="meta-label">UPDATED</span>
                                            <span className="meta-value">{new Date(data.updated).toLocaleDateString()}</span>
                                        </div>
                                    )}
                                </div>

                                <div className="policy-actions" style={{ justifyContent: 'space-between' }}>
                                    {props.activeFilter === "All" && (
                                        <div className="status-badge" style={{
                                            alignSelf: 'center',
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            fontSize: '0.75rem',
                                            fontWeight: 'bold',
                                            backgroundColor: data.status === 1 || data.status === "1" ? '#e6fffa' :
                                                data.status === 2 || data.status === "2" ? '#fffaf0' : '#f7fafc',
                                            color: data.status === 1 || data.status === "1" ? '#38b2ac' :
                                                data.status === 2 || data.status === "2" ? '#ed8936' : '#718096'
                                        }}>
                                            {data.status === 1 || data.status === "1" ? 'Active' :
                                                data.status === 2 || data.status === "2" ? 'Draft' : 'Archived'}
                                        </div>
                                    )}
                                    <div className="d-flex align-items-center" style={{ marginLeft: 'auto', gap: '8px' }}>
                                        {/* Sign Button for Employees */}
                                        {(isAdmin !== "1" && (data.status === 1 || data.status === "1")) && (
                                            <>
                                                {props.signedPolicies && props.signedPolicies.includes(data._id) ? (
                                                    <span className="badge badge-success p-2" title="You have signed this policy">
                                                        <i className="fa fa-check mr-1"></i> Signed
                                                    </span>
                                                ) : (
                                                    <button className="btn btn-sm btn-outline-success font-weight-bold" onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleSignClick(data._id);
                                                    }} title="Sign Policy" style={{ minWidth: '80px' }}>
                                                        Sign Policy
                                                    </button>
                                                )}
                                            </>
                                        )}

                                        {(isAdmin === "4" || isAdmin === "1") && (
                                            <button className="btn-icon edit-btn" onClick={(e) => {
                                                e.stopPropagation();
                                                history.push(`/policies/edit/${data._id}`);
                                            }} title="Edit">
                                                <i className="fa fa-pencil"></i>
                                            </button>
                                        )}
                                        <button className="btn-icon view-btn" onClick={(e) => { e.stopPropagation(); handleViewHistory(data._id) }} title="View History">
                                            <i className="fa fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                {/* Add New Policy Card */}
                {(isAdmin === "4" || isAdmin === "1") && (
                    <div className={`policy-new-card add-policy-card d-flex ${props.viewMode === 'list' ? 'align-items-center justify-content-center' : 'flex-column align-items-center justify-content-center'}`}
                        onClick={() => props.handleOpenAddEditModal && props.handleOpenAddEditModal("Add")}>
                        <div className="add-icon-circle change-cursor">
                            <i className="fa fa-plus"></i>
                        </div>
                        <h5 className="mt-3 change-cursor">Add New Policy</h5>
                        <p className="text-muted text-center small change-cursor">Click to create a new policy item</p>
                    </div>
                )}

                <ViewPolicyHistoryModal
                    show={openHistoryModal}
                    closeModal={closeModal}
                    policyId={privacyId}
                />

                <ViewUploadedPdf show={openViewDoc} doc={doc} closeModal={closeModal} />

                <SignPolicyModal
                    show={openSignModal}
                    closeModal={() => setOpenSignModal(false)}
                    policyIds={selectedPolicyIds} // Pass array
                    onSignSuccess={handleSignSuccess}
                    signPolicy={signPolicy}
                    bulkSignPolicy={bulkSignPolicy} // Pass bulk function
                    isBulk={isBulkSigning}
                />

                <DeletePolicyModal
                    openDeleteModal={openDeleteModal}
                    privacyId={privacyId}
                    dispatch={dispatchProps}
                    closeModal={closeModal}
                    getPolicyList={getPolicyList}
                />
            </div >
        </>
    );
};


export default PolicyCard;
